"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const ModalContainer_1 = require("./ModalContainer");
const ModalFooter_1 = require("./ModalFooter");
function Modal({ isOpen, onCloseButtonClick, children, size, height = 'short', footerButtonText, onFooterButtonClick, hasFooter = true }) {
    return ((0, jsx_runtime_1.jsx)(ModalContainer_1.ModalContainer, Object.assign({ isOpen: isOpen, onClose: onCloseButtonClick, centerChild: true }, { children: ({ active }) => ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: (0, classnames_1.default)('flex', 'flex-col', 'bg-white', 'relative', 'transition-all', 'duration-300', 'rounded-xl', 'shadow-lg', 'h-full', {
                'opacity-0 translate-y-28': !isOpen || !active,
                'opacity-100 translate-y-0 delay-[150ms] duration-300': isOpen && active,
                'sm:w-[450px]': size === 'x-small',
                'sm:w-[336px]': size === 'small',
                'sm:w-[512px]': size === 'medium',
                'sm:w-[864px]': size === 'large',
                'sm:h-[300px]': height === 'mini',
                'sm:h-[440px]': height === 'short',
                'sm:h-[640px]': height === 'medium',
                'sm:h-[840px]': height === 'tall'
            }) }, { children: [children, hasFooter ? ((0, jsx_runtime_1.jsx)(ModalFooter_1.ModalFooter, { size: size, onCloseButtonClick: onCloseButtonClick, onFooterButtonClick: onFooterButtonClick, footerButtonText: footerButtonText })) : null] }))) })));
}
exports.Modal = Modal;
//# sourceMappingURL=Modal.js.map